import { useState, useRef, useEffect } from "react";
import { TextField } from "@mui/material";
import { KEYBOARD_KEYS } from "const";

function QtyTextField({ value, onCommit, onChange, sx, inputRef, placeholder, disabled, onKeyDown }) {
  const [local, setLocal] = useState(String(value ?? ""));
  const fallbackRef = useRef(null);
  const activeRef = inputRef || fallbackRef;

  useEffect(() => {
    const isActive = activeRef.current && document.activeElement === activeRef.current;
    if (!isActive) {
      setLocal(String(value ?? ""));
    }
  }, [value, activeRef]);

  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
      const nextVal = raw === "." ? "0." : raw;
      setLocal(nextVal);
      if (onChange) {
        onChange(nextVal);
      }
    }
  };

  const handleBlur = () => {
    const cleaned = local.endsWith(".") ? local.slice(0, -1) : local;
    const num = parseFloat(cleaned);
    const committed = isNaN(num) ? 0 : num;
    setLocal(String(committed));
    if (onCommit) {
      onCommit(committed);
    } else if (onChange) {
      onChange(String(committed));
    }
  };

  return (
    <TextField
      type="text"
      variant="standard"
      InputProps={{ disableUnderline: true }}
      value={local}
      inputRef={activeRef}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      onFocus={(e) => {
        e.target.select();
      }}
      onBlur={handleBlur}
      onKeyDown={(e) => {
        if (e.key === KEYBOARD_KEYS.ENTER) {
          e.target.blur();
        }
        if (onKeyDown) {
          onKeyDown(e);
        }
      }}
      inputProps={{ inputMode: "decimal" }}
      sx={sx}
    />
  );
}

export default QtyTextField;
